export const menuItems = [
    {
        label: "Dashboard",
        icon: "mdi mdi-apps",
        link: "/",
        perm: "view_dashboard",
    },
    {
        label: "Members",
        icon: "mdi mdi-account-multiple-plus",
        perm: "view_members",
        subItems: [
            {
                label: "Member Accounts",
                link: "/view-members",
                perm: "view_members",
            },
            {
                label: "Applicants",
                link: "/applicants",
                perm: "view_members",
            },
            {
                label: "Membership Fees",
                link: "/membership-fees",
                perm: "view_membershipfees",
            },
            {
                label: "Registration Fees",
                link: "/registration-fees",
                perm: "view_membershipfees",
            },
            {
                label: "Accounts Balances",
                link: "/account-balances",
                perm: "view_members",
            },
        ],
    },
    {
        label: "Savings",
        icon: "mdi mdi-cash-multiple",
        perm: "view_savings",
        subItems: [
            {
                label: "Savings",
                link: "/savings",
                perm: "view_savings",
            },
            {
                label: "Shares",
                link: "/shares",
                perm: "view_shares",
            },
            {
                label: "Withdraws",
                link: "/withdraws",
                perm: "view_withdraws",
            },
            {
                label: "Withdraw Charges",
                link: "/withdraw-charges",
                perm: "view_withdraw_charges",
            },
        ],
    },
    {
        label: "Loans",
        icon: "mdi mdi-cash",
        perm: "view_loans",
        subItems: [
            {
                label: "Loan Application",
                link: "/applications",
                perm: "view_loanapplications",
            },
            {
                label: "Loan Disbursement",
                link: "/disbursements",
                perm: "view_loandisbursement",
            },
            {
                label: "Running Loans",
                link: "/running-loans",
                perm: "view_runningloans",
            },
            {
                label: "Closed Loans",
                link: "/closed-loans",
                perm: "view_runningloans",
            },
            {
                label: "Loan Arrears",
                link: "/loan-arrears",
                perm: "view_runningloans",
            },
            {
                label: "Loan Charges",
                link: "/loan-charges",
                perm: "view_loan_charges",
            },
            {
                label: "Loan Products",
                link: "/loan-products",
                perm: "view_loan_products",
            },
        ],
    },
    {
        label: "Returns",
        icon: "mdi mdi-clipboard-list",
        perm: "view_returns",
        subItems: [
            {
                label: "Investments Returns",
                link: "/investment-returns",
                perm: "view_investment_returns",
            },
            {
                label: "Investments",
                link: "/investments",
                perm: "view_investment",
            },
            {
                label: "Member Interests",
                link: "/member-interests",
                perm: "member_interests",
            },
            {
                label: "Interests Payouts",
                link: "/interest-payouts",
                perm: "interest_payouts",
            },
            {
                label: "ShareHolder Dividends",
                link: "/shareholder-dividends",
                perm: "share_holder_dividends",
            },
            {
                label: "Dividend Payouts",
                link: "/dividend-payouts",
                perm: "dividend_payouts",
            },
        ],
    },
    {
        label: "Expenses",
        icon: "mdi mdi-database",
        perm: "view_expenses",
        subItems: [
            {
                label: "Record Expense",
                link: "/record-expense",
                perm: "record_expenses",
            },
            {
                label: "View Expenses",
                link: "/view-expenses",
                perm: "recorded_expenses",
            },
            {
                label: "Expense Items",
                link: "/expense-items",
                perm: "view_expense_items",
            },
            {
                label: "Expense Categories",
                link: "/expense-categories",
                perm: "view_expense_categories",
            },
        ],
    },
    {
        label: "SMS Center",
        icon: "mdi mdi-chat",
        link: "/sms-center",
        perm: "view_sms_center",
        // subItems: [
        //     {
        //         label: "Send Messages",
        //         link: "/smscenter",
        //         perm: "view_sms_center",
        //     },
        //     {
        //         label: "Subscriptions",
        //         link: "/smspurchase",
        //         perm: "purchase_bundles",
        //     },
        // ],
    },
    {
        label: "Settings",
        icon: "mdi mdi-cog",
        perm: "view_settings",
        subItems: [
            {
                label: "System Users",
                link: "/users",
                perm: "view_system_users",
            },
            {
                label: "System Roles",
                link: "/roles",
                perm: "view_system_roles",
            },
            {
                label: "System Permissions",
                link: "/permissions",
                perm: "system_permissions",
            },
            {
                label: "Payment Options",
                link: "/payment-options",
                perm: "view_payment_options",
            },
            {
                label: "Saving Packages",
                link: "/saving-packages",
                perm: "view_saving_packages",
            },
            {
                label: "Financial Years",
                link: "/financial-years",
                perm: "view_financial_years",
            },
            {
                label: "Audit Trails",
                link: "/audits",
                perm: "view_audit_trails",
            },
            {
                label: "Company Settings",
                link: "/settings",
                perm: "view_settings",
            },
            {
                label: "Company Profile",
                link: "/profile",
                perm: "view_company_profile",
            },
            {
                label: "Subscriptions",
                link: "/subscriptions",
                perm: "view_settings",
            },
        ],
    },
];
